import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import RoleAdapter from "../../../adapters/RoleAdapter";

export default class GetMarketplaceUsersResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "users": [
                    {
                        'user': {
                            'email': 'michael@dundermifflin.com'
                        },
                        'delivery_site_user_roles': [
                            {
                                'role': 'FRONTOFFICE_OPERATIONAL_ROLE',
                                'delivery_site': {
                                    'name': 'Scranton',
                                    'address': '1725 Slough Ave',
                                    'city': 'Scranton',
                                    'customer': {
                                        'code': '1234',
                                        'fantasy_name': 'Michael',
                                        'business_name': 'Dunder Mifflin',
                                        'taxpayer_identification_number': '334333322'
                                    }
                                }
                            }, {
                                'role': 'FRONTOFFICE_OPERATIONAL_ROLE',
                                'delivery_site': {
                                    'name': 'Stamford',
                                    'address': '333 Ludlow St',
                                    'city': 'Stamford',
                                    'customer': {
                                        'code': '2345',
                                        'fantasy_name': 'David',
                                        'business_name': 'Sabre Corporation',
                                        'taxpayer_identification_number': '334456338'
                                    }
                                }
                            }]
                    }
                ]
            },
            errors: []
        }
    }

    users() {
        return this.content().users.map(userWithRoles => {
            const customersBusinessNames = userWithRoles.delivery_site_user_roles.map(deliverySiteUserRole => deliverySiteUserRole.delivery_site.customer.business_name);
            const deliverySitesNames = userWithRoles.delivery_site_user_roles.map(deliverySiteUserRole => deliverySiteUserRole.delivery_site.name);
            const roles = userWithRoles.delivery_site_user_roles.map(deliverySiteUserRole => this._adaptRole(deliverySiteUserRole.role));

            return {
                userEmail: userWithRoles.user.email,
                customers: this._adaptListWithoutRepetitions(customersBusinessNames),
                deliverySites: this._adaptListWithoutRepetitions(deliverySitesNames),
                roles: this._adaptListWithoutRepetitions(roles),
            }
        })
    }

    _adaptListWithoutRepetitions(aList){
        return this._adaptList(this._withoutRepetitions(aList))
    }

    _withoutRepetitions(aListOfElements) {
        return [...new Set(aListOfElements)]
    }

    _adaptList(aList) {
        return aList.join(", ")
    }

    _adaptRole(role) {
        return new RoleAdapter(role).adapt()
    }
}
